import { ReportSendEmailModel } from './../../../models/report/report-send-email.model';
import  { MutationTree } from "vuex";
import ReportStoreTypes from "./define-types.store";
import {
  IReportSendEmailModel,
  ReportSendEmailUpdateModel
} from "../../../models/report";
import { ISendMessageState } from './states.store';
import { deepClone } from 'fast-json-patch/lib/core';

const descriptionMutations: MutationTree<ISendMessageState> = <MutationTree<
ISendMessageState
  >>{
    /** STORE TO STATE */
    [ReportStoreTypes.Set.STORE_SENDEMAIL]: (
      state: ISendMessageState,
      model: IReportSendEmailModel
    ) => {
      model.SubjectEN = model.SubjectEN || null;
      model.SubjectFR = model.SubjectFR || null;
      model.SubjectNL = model.SubjectNL || null;

      state.sendEmail = model;
    },

    /** UPDATE STATE */
    [ReportStoreTypes.Set.UPDATE_SENDEMAIL]: (
      state: ISendMessageState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.sendEmail) return;
      state.sendEmail[updateModel.Field] = updateModel.Value;
    },

    /** UPDATE ITEM TO ARRAY FIELD STATE */
    [ReportStoreTypes.Set.UPDATE_iTEM_ARRAY_FIELD_SENDEMAIL]: (
      state: ISendMessageState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.sendEmail) return;

      // REMOVE ALL OLDS ITEM
      let items = state.sendEmail[updateModel.Field];
      if (items != null && items.length > 0) {
        for (let index = 0; index < items.length; index++) {
          state.sendEmail[updateModel.Field].splice(index, 1);
        }
      }

      // UPDATE NEW ITEMS
      state.sendEmail[updateModel.Field] = updateModel.Value;
    },

    /** PUSH ITEM TO ARRAY FIELD STATE */
    [ReportStoreTypes.Set.PUSH_iTEM_ARRAY_FIELD_SENDEMAIL]: (
      state: ISendMessageState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.sendEmail) return;
      if (!state.sendEmail[updateModel.Field]) state.sendEmail[updateModel.Field] = [];
      let existItem = state.sendEmail[updateModel.Field].find(c => c.Id == updateModel.Value);
      if (existItem) return;
      state.sendEmail[updateModel.Field].push(updateModel.Value);
    },

    /** REMOVE ITEM FROM ARRAY FIELD STATE */
    [ReportStoreTypes.Set.REMOVE_ITEM_ARRAY_FIELD_SENDEMAIL]: (
      state: ISendMessageState,
      updateModel: ReportSendEmailUpdateModel
    ) => {
      if (!state.sendEmail) return;
      if (!state.sendEmail[updateModel.Field]) state.sendEmail[updateModel.Field] = [];
      let arr = [];
      arr = state.sendEmail[updateModel.Field];
      let index = arr.indexOf(updateModel.Value);
      if (index > -1)
        state.sendEmail[updateModel.Field].splice(index, 1);
    },

    /** DELETE STATE */
    [ReportStoreTypes.Set.DELETE_SENDEMAIL]: (state: ISendMessageState) => {
      state.sendEmail = null;
    },

    /** INIT STATE */
    [ReportStoreTypes.Set.INIT_SENDEMAIL]: (state: ISendMessageState, moduleId: number) => {
      state.sendEmail = new ReportSendEmailModel();
      state.sendEmail.Module = moduleId;
    },
    /** DEMAND INFOS */
    [ReportStoreTypes.Set.DEMAND_INFOS]: (state: ISendMessageState, info) => {
      state.demandInfos = deepClone(info);
    },
    /** PERSON INFOS */
    [ReportStoreTypes.Set.PERSON_INFOS]: (state: ISendMessageState, info) => {
      state.personInfos = deepClone(info);
    },
    /** DESIGNED MESSAGE TEMPLATES */
    [ReportStoreTypes.Set.DESINGED_MESSAGE_TEMPLATES]: (state: ISendMessageState, templates) => {
      state.designedMessageTemplates = deepClone(templates);
    },
  };

export default descriptionMutations;
